import React, { useState } from "react";
import Checkbox from "./Checkbox";

const CheckboxOption = ({
  heading,
  options,
  selectedOption,
  onSelect,
}: {
  heading: string;
  options: string[];
  selectedOption: number;
  onSelect: Function;
}) => {
  const [currentOption, setCurrentOption] = useState(selectedOption);
  return (
    <div style={styles.mainColumn}>
      <p style={styles.heading}>{heading}</p>
      <div style={styles.optionsColumn}>
        {options.map((option, index) => (
          <div style={styles.optionRow}>
            <Checkbox
              state={currentOption == index}
              onClick={() => {
                setCurrentOption(index);
                onSelect(index);
              }}
            />
            <p style = {styles.optionText}>{option}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  mainColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
  },
  heading: {
    fontSize: "var(--form-heading-font-size)",
    color: "var(--dark-grey)",
  },
  optionsColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  optionRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "1rem",
  },
  optionText: {
    fontSize: "var(--form-option-font-size)",
    color: "var(--dark-grey)",
  }
};

export default CheckboxOption;
